import { Note } from "../gateway/Note/Note";

export class GetNotesUsecase {
    constructor() {
        this.NoteGateway = new Note();
    }

    async execute({ accountingId, companyId, reportId, options } = {}) {
        const payload = this.sanitizeInput({
            accountingId,
            companyId,
            reportId,
            options
        });
        if (!payload.accountingId || !payload.companyId) return null;
        if (!payload.options?.date?.year || !payload.options?.date?.month)
            return [];
        const notes = await this.NoteGateway.get(payload);
        return notes || [];
    }

    sanitizeInput({ accountingId, companyId, reportId, options = {} } = {}) {
        const sanitizedAccountingId = String(accountingId || "").trim();
        const sanitizedCompanyId = String(companyId || "").trim();
        const sanitizedReportId = reportId ? String(reportId).trim() : "";
        const year = Number(options?.date?.year);
        const month = Number(options?.date?.month);
        const sanitizedYear = Number.isNaN(year) ? null : year;
        const sanitizedMonth = Number.isNaN(month) ? null : month;
        const visualizationsIds = Array.isArray(options?.visualizationsIds)
            ? options.visualizationsIds
                  .filter(Boolean)
                  .map((id) => String(id).trim())
            : undefined;
        return {
            accountingId: sanitizedAccountingId || null,
            companyId: sanitizedCompanyId || null,
            reportId: sanitizedReportId || undefined,
            options: {
                reportId: options?.reportId
                    ? String(options.reportId).trim()
                    : undefined,
                dashboardId: options?.dashboardId
                    ? String(options.dashboardId).trim()
                    : undefined,
                scenarioId: options?.scenarioId
                    ? String(options.scenarioId).trim()
                    : undefined,
                date: {
                    year: sanitizedYear,
                    month: sanitizedMonth
                },
                period: options?.period
                    ? String(options.period).trim()
                    : undefined,
                visualizationsIds
            }
        };
    }
}
